// extracted by mini-css-extract-plugin
var _1 = "active-media-preview";
var _2 = "base-link";
var _3 = "#000000";
var _4 = "#76F366";
var _5 = "#EB8632";
var _6 = "#ECC834";
var _7 = "#21FC87";
var _8 = "#EA4A30";
var _9 = "#C7EA45";
var _a = "#272B2B";
var _b = "#BDBDBD";
var _c = "#7D7D7D";
var _d = "#6A0DAD";
var _e = "#3A65FF";
var _f = "#4A90E2";
var _10 = "#ffffff";
var _11 = "formLabel";
var _12 = "formLabelActiveFilter";
var _13 = "formLabelNonActiveFilter";
var _14 = "reset-button";
var _15 = "1200px";
var _16 = "992px";
var _17 = "1366px";
var _18 = "768px";
var _19 = "1475px";
var _1a = "576px";
var _1b = "1600px";
var _1c = "320px";
var _1d = "2500px";
var _1e = "single-page-responsive-font-size";
export { _1 as "active-media-preview", _2 as "base-link", _3 as "colorBlack", _4 as "colorGradeEX", _5 as "colorGradeFR", _6 as "colorGradeGD", _7 as "colorGradeOU", _8 as "colorGradePR", _9 as "colorGradeVG", _a as "colorNeutral", _b as "colorNeutralLighest", _c as "colorNeutralLight", _d as "colorNonOwnerSweetLine", _e as "colorOwnerSweetLine", _f as "colorRegularLinks", _10 as "colorWhite", _11 as "formLabel", _12 as "formLabelActiveFilter", _13 as "formLabelNonActiveFilter", _14 as "reset-button", _15 as "screenlg", _16 as "screenmd", _17 as "screenml", _18 as "screensm", _19 as "screenxlg", _1a as "screenxs", _1b as "screenxxlg", _1c as "screenxxs", _1d as "screenxxxlg", _1e as "single-page-responsive-font-size" }
export default { "active-media-preview": _1, "base-link": _2, "colorBlack": _3, "colorGradeEX": _4, "colorGradeFR": _5, "colorGradeGD": _6, "colorGradeOU": _7, "colorGradePR": _8, "colorGradeVG": _9, "colorNeutral": _a, "colorNeutralLighest": _b, "colorNeutralLight": _c, "colorNonOwnerSweetLine": _d, "colorOwnerSweetLine": _e, "colorRegularLinks": _f, "colorWhite": _10, "formLabel": _11, "formLabelActiveFilter": _12, "formLabelNonActiveFilter": _13, "reset-button": _14, "screenlg": _15, "screenmd": _16, "screenml": _17, "screensm": _18, "screenxlg": _19, "screenxs": _1a, "screenxxlg": _1b, "screenxxs": _1c, "screenxxxlg": _1d, "single-page-responsive-font-size": _1e }
